import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';

//css
import './404.css';

export default class NotFound extends React.Component {

    render() {
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>A página não foi encontrada</title>
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >A PÁGINA NÃO FOI ENCONTRADA</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<Grid container spacing={16} style={{marginTop:60, marginBottom: 60}} >
							<Grid item md={12} xs={12} >
								<div className="numbclass" >
									<Typography variant="h1" >404</Typography>
								</div>
							</Grid>
							<Grid item md={12} xs={12} >
								<div className="textclass" >
									<Typography variant="h6" >Infelizmente não encontramos a página que você tentou acessar. Tente novamente!</Typography>
								</div>
							</Grid>
						</Grid>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/404/index.js